import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import CareersPage from "./pages/CareersPage";
import AdminPage from "./pages/AdminPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<CareersPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
  );
}
export default App;
